module.exports = __webpack_public_path__ + "img/Girl_020017.dbc0045c.png";